import { NAMESPACE } from 'locale'
import { reportsConstants } from 'locale/team'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const Grid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const ProfileFieldGrid = ({ children }: { children: ReactNode }) => (
  <Grid>{children}</Grid>
)

const Row = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`
const Label = styled.div`
  font-size: 16px;
  color: ${({ theme }) => theme.color.neutral.color4};
`
const Value = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.color.neutral.color3};
  white-space: pre-wrap;
  overflow-wrap: anywhere;
`

type ProfileFieldRowProps = {
  label: string
  value?: string | null
  testId?: string
}

const ProfileFieldRow = ({ label, value, testId }: ProfileFieldRowProps) => {
  const { t } = useTranslation(NAMESPACE.TEAM)
  return (
    <Row data-testid={testId}>
      <Label>{label}</Label>
      <Value>{value || t(reportsConstants.PROFILE_VIEW_NO_INFO)}</Value>
    </Row>
  )
}

export default ProfileFieldRow
